export const getPreferredLanguage = (): 'kh' | 'en' => {
	const preferredLanguages = navigator.languages ?? [];

	const baseLang =
		preferredLanguages
			.map(l => l.split('-')[0])
			.find(l => l === 'km' || l === 'en') ?? 'en';

	return baseLang === 'km' ? 'kh' : 'en';
};
